var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-connection-indicator",class:{ connected: _vm.device.socketConnected },attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }